export default __webpack_public_path__ + "_/shared_modules/sprites/dist/sprite-icons-141d8fe522c1d404ebfca95b6fba5b32.png";